import { render, staticRenderFns } from "./MemberMyConsultation.vue?vue&type=template&id=66bc117c&scoped=true&"
import script from "./MemberMyConsultation.vue?vue&type=script&lang=js&"
export * from "./MemberMyConsultation.vue?vue&type=script&lang=js&"
import style0 from "./MemberMyConsultation.vue?vue&type=style&index=0&id=66bc117c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bc117c",
  null
  
)

export default component.exports